import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const NotFound = () => (
  <div className='not-found'>
    <Helmet>
        <title>Page not found</title>
        <meta name="robots" content="noindex" />
    </Helmet>
    <h1>404 - Page Not Found!</h1>
    <Link to="/">Go Home</Link>
  </div>
);

export default NotFound;